
const NordenProjectView = () => {
   return (
      <div className="p-3 max-w-xl bg-[#F9F9F9] mx-auto mb-3 pt-16 pb-7 rounded-b-md">
         <div className="">
            <p className="text-4xl mb-1 font-light ">Work</p>
            <p className="text-neutral-600">Showcasing my latest projects crafted <br/> with creativity and precision.</p>
         </div>
      </div>
   )
}

export default NordenProjectView;
